import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import "./ECommerceComponents.css";
import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import { calculateCartSubtotal, calculateCartTotal, cart_protected_value, product_protected_value, professional_assembly_value, security_key, Url } from "../../Services/Api";
import { ppValue, paValue } from '../../Services/Env';
import BottomToust from "../../Components/BottomToust/BottomToust";
import InputIconField from "../UI-Controls/InputField/InputIconField";
import { format } from "date-fns";
import { CiWarning } from "react-icons/ci";
import generateInvoicePDF from "./orderInvoice";

const ViewCartInt = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const OrdeR = location.state || {};
    const [loading, setLoading] = useState(false);
    const [loadingNote, setLoadingNote] = useState(false);
    const [orderNote, setOrderNote] = useState("");
    const [orderNotes, setOrderNotes] = useState([]);
    const [showMessage, setShowMessage] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [showConfirm, setShowConfirm] = useState(false);
    const [currentRowId, setCurrentRowId] = useState(null);
    const [margins, setMargins] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [cartProtected, setCartProtected] = useState(OrdeR?.cart_protected);
    const [professionalAssembled, setProfessionalAssembled] = useState(OrdeR?.professional_assembled);
    const tooltipRefs = useRef([]);
    const modalRef = useRef(null);
    const [orderDate, setOrderDate] = useState(
        OrdeR?.cart?.createdAt ? formatDate(OrdeR?.cart?.createdAt) : ""
    );
    const [userLocation, setUserLocation] = useState({
        city: "",
        country: "",
        region: "",
        lng: 0,
        lat: 0
    })
    const { items = [] } = OrdeR;


    async function getLocationFromIP(ip) {
        try {
            // Replace ip with "ip" variable; use "json" for JSON response
            const url = `https://ip-api.com/json/${ip}`;
            const { data } = await axios.get(url);

            if (data.status === "success") {
                setUserLocation(
                    {
                        ip: ip,
                        country: data.country,
                        region: data.regionName,
                        city: data.city,
                        lat: data.lat,
                        lon: data.lon,
                        isp: data.isp
                    }
                )
                return {
                    ip: ip,
                    country: data.country,
                    region: data.regionName,
                    city: data.city,
                    lat: data.lat,
                    lon: data.lon,
                    isp: data.isp
                };
            } else {
                console.log("Failed to get location:", data.message);
                return null;
            }
        } catch (error) {
            console.error("Error fetching location:", error);
            return null;
        }
    }


    useEffect(() => {
        if (tooltipRefs.current.length > 0) {
            const calculatedMargins = tooltipRefs.current.map((tooltip, index) => {
                if (tooltip) {
                    const lineHeight = 18;
                    const padding = 10;
                    const textHeight = tooltip.scrollHeight;
                    const lines = Math.ceil((textHeight - padding) / lineHeight);
                    return index === 0 ? 75 : 35 + lines * 7;
                }
                return 35;
            });

            setMargins(calculatedMargins);
        }
    }, [orderNotes]);

    const handleCloseMessageModal = () => {
        setShowMessage(false);
    };

    useEffect(() => {
        if (showMessage) {
            const timeOut = setTimeout(() => {
                setShowMessage(false);
            }, 3000);

            return () => clearTimeout(timeOut);
        }
    }, [showMessage]);

    useEffect(() => {
        if (OrdeR?.order_notes) {
            setOrderNotes(OrdeR?.order_notes);
        }
    }, [OrdeR?.order_notes]);

    useEffect(() => {
        const handleDeleteClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                cancelDelete();
            }
        };

        document.addEventListener("mousedown", handleDeleteClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleDeleteClickOutside);
        };
    }, []);

    function formatDate(isoDate) {
        const date = new Date(isoDate);
        return date.toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    }

    useEffect(() => { console.log(OrdeR, "here details"); getLocationFromIP(OrdeR?.cart?.ipAddress).then(location => console.log(location)); }, [OrdeR])

    const formatNoteDate = (isoString) => {
        return format(new Date(isoString), "MMMM dd, yyyy 'at' hh:mm a");
    };

    const handleNoteChange = (e) => {
        setOrderNote(e.target.value);
    };

    const formatPaymentMethod = (method) => {
        if (!method) return "";
        return method
            .replace(/-/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const handleSubmitNote = async () => {
        if (!orderNote.trim()) return;

        let successMessage = "Order note submitted successfully!";
        let warningMessage = "Failed to submit order note.";

        setLoadingNote(true);
        const token = sessionStorage.getItem('authToken');
        const headers = {
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
        };

        try {
            const response = await axios.post(
                `${Url}/api/v1/orders/add-note/${OrdeR?._id}`,
                { note: orderNote },
                { headers: headers }
            );

            if (response.status === 200) {
                setOrderNotes([...orderNotes, orderNote]);
                setOrderNote("");
                setToastMessage(successMessage);
                setShowMessage(true);
                setTimeout(() => {
                    navigate("/E-Commerce/All-Orders");
                }, 2500);
            }
        } catch (error) {
            console.error("Error adding order note:", error);
            setToastMessage(warningMessage);
            setShowMessage(true);
        } finally {
            setLoadingNote(false);
        }
    };

    const confirmDelete = (noteId) => {
        setCurrentRowId(noteId);
        setShowConfirm(true);
    };

    const handleDelete = () => {
        if (currentRowId) {
            handleDeleteNote(currentRowId);
        }
    };

    const handleDeleteNote = async (noteId) => {
        if (!noteId) return;

        setIsLoading(true);
        setIsActive(true);

        const token = sessionStorage.getItem('authToken');
        const headers = {
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
        };

        try {
            const response = await axios.delete(
                `${Url}/api/v1/orders/delete-note/${OrdeR?._id}/${noteId}`,
                { headers }
            );

            if (response.status === 200) {
                setOrderNotes(orderNotes.filter((note) => note._id !== noteId));
                setToastMessage("Order note deleted successfully!");
                setShowMessage(true);
            }
        } catch (error) {
            console.error("Error deleting order note:", error);
            setToastMessage("Failed to delete order note.");
            setShowMessage(true);
        } finally {
            setTimeout(() => {
                setIsLoading(false);
                setIsActive(false);
            }, 5000);
            setShowConfirm(false);
        }
    };

    const cancelDelete = () => {
        setShowConfirm(false);
    };





    if (loading) return <p>Loading...</p>;

    return (
        <div className="EditOrderMainPage">
            {loadingNote && (
                <div className="backdrop">
                    <MainLoader />
                </div>
            )}

            <div className="OrderSection-01">
                <div className="RowAlign">
                    {/* Order Edit Page - LeftSide */}
                    <div className="LeftSection">

                        {/* Order Detail Section */}
                        <div className="Order-Leftside">

                            <div className="OrderMainContainer">
                                <span className="Order-Header" style={{ width: "70%" }}>Order Details </span>
                                {/* <button onClick={() => {
                  generateInvoicePDF(OrdeR)
                }} className="print_btn_inv">Print</button> */}
                            </div>

                            <div className="OrderBodyContainer">
                                <div className="Details-Row-02">
                                    <div className="RowData-Start-View" style={{ marginBottom: "0" }}>
                                        <p className="Details-Headings">General Info</p>
                                        <span className="Order-Rendering-Span-Labels" >
                                            Date & Time:
                                        </span>
                                        <input
                                            type="text"
                                            value={orderDate}
                                            readOnly
                                            className="Order-Rendering-Fields"
                                        />
                                        <label className="Order-Rendering-Labels">
                                            Status:
                                        </label>
                                        <input
                                            type="text"
                                            value={"Abandoned"}
                                            readOnly
                                            className="Order-Rendering-Fields"
                                        />
                                        <label className="Order-Rendering-Labels" >
                                            Customer:
                                        </label>
                                        <input
                                            type="text"
                                            value={"Guest"}
                                            readOnly
                                            className="Order-Rendering-Fields"
                                        />
                                        {/* <label className="Order-Rendering-Labels" >
                      User Note:
                    </label>
                    <input
                      type="text"
                      value={OrdeR?.customer_note}
                      readOnly
                      className="Order-Rendering-Fields"
                    /> */}
                                        {/* <label
                      style={{
                        fontFamily: "var(--font-family)",
                        fontSize: "var(--font-size-medium)",
                        fontWeight: "var(--font-weight-semi-bold)",
                        color: "var(--black-color)",
                        lineHeight: "18px",
                        marginTop: "25px",
                        marginBottom: "7px",
                      }}
                    >
                      Payment Method
                    </label>
                    <input
                      type="text"
                      value={formatPaymentMethod(OrdeR?.payment_method)}
                      readOnly
                      className="Order-Rendering-Fields"
                    /> */}
                                    </div>

                                    <div className="RowData-Mid-View">
                                        <div className="Main-Details-Heading">
                                            <p className="Details-Headings-Rest">Billing Address</p>
                                        </div>
                                        <span>{userLocation.region} {userLocation.city}</span>
                                        <span>{userLocation.country}</span>
                                        <span style={{
                                            marginTop: "10px",
                                            fontSize: "13px",
                                            fontWeight: 500,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            justifyContent: "flex-start"
                                        }}>
                                            <span
                                                style={{
                                                    marginTop: "0px",
                                                    fontSize: "13px",
                                                    fontWeight: 500,
                                                }}
                                            >
                                                Email
                                            </span>
                                            <span
                                                style={{
                                                    textDecoration: "underline",
                                                    color: "blue",
                                                    cursor: "pointer",
                                                    marginTop: "0px",
                                                }}
                                            >
                                                ---
                                            </span>
                                        </span>

                                        <span style={{
                                            marginTop: "10px",
                                            fontSize: "13px",
                                            fontWeight: 500,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            justifyContent: "flex-start"
                                        }}>
                                            <span
                                                style={{
                                                    marginTop: "0px",
                                                    fontSize: "13px",
                                                    fontWeight: 500,
                                                }}
                                            >
                                                Phone No.
                                            </span>
                                            <span
                                                style={{
                                                    textDecoration: "underline",
                                                    color: "blue",
                                                    cursor: "pointer",
                                                    marginTop: "0px",
                                                }}
                                            >
                                                ---
                                            </span>
                                        </span>


                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* Cart Details Section */}
                        <div className="Order-Leftside">
                            <div className="OrderMainContainer">
                                <span className="Order-Header">Cart Details</span>
                                <div className="Order-Header-Right" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)" }}>
                                    <span className="Right-Content">Cost</span>
                                    <span className="Right-Content">Qty</span>
                                    <span className="Right-Content">Total</span>
                                </div>
                            </div>
                            <div className="OrderBodyContainer">
                                {OrdeR?.cart?.products?.map((item, index) => {
                                    const price = item?.sale_price && item?.sale_price !== "" ? item?.sale_price : item?.regular_price;
                                    const cost =
                                        (item.is_protected === 1 && OrdeR?.is_all_protected === 0)
                                            ? (price * item.quantity) + product_protected_value
                                            : price * item.quantity;

                                    return (
                                        <div key={item._id || index}>
                                            {/* Individual Cart Row */}
                                            <div className="CartSection-Row" style={{ margin: "10px 0 10px 10px" }}>
                                                <div className="ImgSection" style={{ width: "65%" }}>
                                                    <img
                                                        src={`${Url + item?.image?.image_url}`}
                                                        alt={item.name}
                                                        className="ImageStyle-Order"
                                                    />
                                                    <div className="CartDescription-View">
                                                        <span className="Main-Headings">{item.name}</span>
                                                        <span className="Headings-1st">SKU: {item.sku}</span>

                                                        {/* Render Attributes */}
                                                        {item?.attributes && (
                                                            <div className="AttributesSection-Edit">
                                                                {item?.attributes.map((attribute, attrIndex) => (
                                                                    <div key={attrIndex} className="AttributeItem">
                                                                        <p className="ItemStyling">
                                                                            {attribute?.options[0]?.name || "N/A"}
                                                                        </p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}

                                                        {/* Render Protection Plan only if is_protected === 1 */}
                                                        {item.is_protected === 1 && OrdeR?.cart?.is_all_protected === 0 && (
                                                            <label className="ItemStyling-1st">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={true}
                                                                    style={{
                                                                        marginRight: "5px",
                                                                        marginTop: "3px",
                                                                        accentColor: "green",
                                                                    }}
                                                                    disabled
                                                                />
                                                                Protected (+${product_protected_value})
                                                            </label>
                                                        )}


                                                    </div>

                                                </div>


                                                <div className="AmountHandling-View" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", width: "35%", paddingLeft: "0" }}>
                                                    <span className="Cost-View" style={{ display: "flex", flexDirection: "column", alignItems: "end", gap: "2px" }}>
                                                        <p>${price}</p>
                                                    </span>{" "}
                                                    {/* Calculated Cost */}
                                                    <span className="Qty-View" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "2px", marginLeft: "0" }}>
                                                        <p>{item.quantity}</p>
                                                    </span>{" "}
                                                    {/* Dynamic Quantity */}
                                                    <span className="Total-View" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "2px", marginLeft: "0" }}>
                                                        <p>${cost}</p>
                                                    </span>{" "}
                                                </div>
                                            </div>

                                            {/* Separator */}
                                            {index < items.length - 1 && (
                                                <div className="RowSeparator"></div>
                                            )}
                                        </div>
                                    );
                                })}

                                {/* Order Summary Section */}
                                <div className="CartSection-Row-Summary">
                                    <div className="Order-Total">
                                        <div className="MainContainer">
                                            <span className="Order-Header">Order Summary</span>
                                        </div>

                                        <div className="BodyContainer">
                                            <div className="items-Description">
                                                <span>Sub Total:</span>
                                                <span>${calculateCartSubtotal(OrdeR?.cart)}</span>
                                            </div>

                                            {/* <div className="items-Description">
                        <span>Shipping:</span>
                        {OrdeR?.shipping_lines?.method_id === "METHOD-3" ? <span>Store Pick up </span> : <span>${OrdeR?.shipping_cost?.toFixed(2)}</span>}
                      </div> */}

                                            {/* Protection Plan Display */}
                                            <div className="items-Description">
                                                <span>Protection Plan:</span>
                                                <span>{OrdeR?.cart?.is_all_protected === 1 ? `$${cart_protected_value}` : "$0"}</span>
                                            </div>

                                            {/* Professional Assembly Display */}
                                            <div className="items-Description">
                                                <span>Professional Assembly:</span>
                                                <span>{OrdeR?.cart?.is_professional_assembly === 1 ? `$${professional_assembly_value}` : "$0"}</span>
                                            </div>

                                            {/* <div className="items-Description">
                        <span>Discount:</span>
                        <span>${OrdeR?.discount?.toFixed(2)}</span>
                      </div> */}

                                            {/* <div className="items-Description">
                        <span>Tax:</span>
                        <span>${OrdeR?.tax?.toFixed(2)}</span>
                      </div> */}

                                            <div className="RowSeparator-Total"></div>

                                            <div className="items-TotalDescription">
                                                <span className="TotalDescription">Grand Total:</span>
                                                <span className="TotalDescription">${calculateCartTotal(OrdeR?.cart)}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* Order Edit Page - RightSide */}
                    <div className="RightSection">
                        {/* 1st Row */}
                        <div className="Order-Rightside">
                            <div className="OrderMainContainer">
                                <span className="Order-Header">Customer History</span>
                            </div>

                            <div className="OrderBodyContainer">
                                <div className="Customer-History">
                                    <span className="History-Heading">Total Orders</span>
                                    <span className="History-Value">1</span>
                                    <span className="History-Heading">Total Revenue</span>
                                    <span className="History-Value">${calculateCartTotal(OrdeR?.cart)}</span>
                                    <span className="History-Heading">Average Order Value</span>
                                    <span className="History-Value">${calculateCartTotal(OrdeR?.cart)}</span>
                                </div>
                            </div>
                        </div>

                        {/* 2nd Row */}
                        <div className="Order-Rightside">
                            <div className="OrderMainContainer">
                                <span className="Order-Header">Order Attribution</span>
                            </div>

                            <div className="OrderBodyContainer">
                                <div className="Customer-History">
                                    <span className="History-Heading">Origin</span>
                                    <span className="History-Value">Source: Google</span>
                                    <span className="History-Heading">Device Type</span>
                                    <span className="History-Value">Mobile</span>
                                </div>
                            </div>
                        </div>

                        {/* <div className="Order-Rightside">
              <div className="OrderMainContainer">
                <span className="Order-Header">Order Status</span>
              </div>

              <div className="OrderBodyContainer">

                {orderNotes?.map((note, index) => (
                  <div className="Attribution-Row-02" key={index}>
                    <div
                      className="RowData-Start-Tooltip"
                      style={{ marginTop: `${margins[index] || 35}px` }}
                    >
                      <div className="TooltipContainer">
                        <span
                          className="TooltipText"
                          ref={(el) => (tooltipRefs.current[index] = el)}
                        >
                          {note?.note || "No Note Available"}
                        </span>
                        <span
                          style={{
                            color: "var(--text-color)",
                            fontWeight: "var(--font-weight-medium)",
                            marginLeft: "15px",
                            fontSize: "var(--font-size-small)",
                          }}
                        >
                          {note.updatedAt ? formatNoteDate(note.updatedAt) : "Date not available"}
                        </span>
                        <span
                          style={{
                            color: "#C61B1A",
                            textDecoration: "underline",
                            fontWeight: "var(--font-weight-medium)",
                            marginLeft: "55px",
                            cursor: "pointer",
                          }}
                          onClick={() => confirmDelete(note._id)}
                        >
                          Delete Note
                        </span>

                      </div>
                    </div>
                  </div>
                ))}

                <div className="Attribution-Row-02">
                  <div className="RowData-Start">
                    <InputIconField
                      placeholder="Enter Order Note Here"
                      value={orderNote}
                      name="order_note"
                      onChange={handleNoteChange}
                      readOnly={false}
                      onSubmit={handleSubmitNote}
                    />
                  </div>
                </div>

              </div>
            </div> */}
                    </div>
                </div>
            </div>

            {/* --- (PopUp) To Handle Confiramtion for Delete Operation of Order Note --- */}
            {showConfirm && (
                <div className="Delete-Confirmation-Modal">
                    <div className="ModalContent" ref={modalRef}>
                        <CiWarning className="warningIcon" />
                        <div className="deleteHeading">Warning</div>
                        <div className="deleteContent">
                            Are you sure you want to delete this Order Note? <br />
                            This action cannot be undone.
                        </div>
                        <div className="separatorLine"></div>
                        <div className="modalActions">
                            <button
                                className="NoteDelete-btn btnSecondary"
                                onClick={cancelDelete}
                            >
                                Cancel
                            </button>

                            <div className="NoteSubmitBtn">
                                <CustomBtn
                                    label={
                                        isLoading ? (
                                            <div className="btnLoader-Note"></div>
                                        ) : (
                                            "Confirm"
                                        )
                                    }
                                    className={`NoteDeletebtn btnDanger ${isActive ? "active" : ""
                                        }`}
                                    disabled={isLoading}
                                    onClick={handleDelete}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <BottomToust
                showMessage={showMessage}
                message={toastMessage}
                handleCloseMessageModal={() => handleCloseMessageModal()}
            />

        </div>
    );
};

export default ViewCartInt;